var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ComIndex',{attrs:{"orderType":5,"exportTitle":"青少年儿童培训订单"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }